import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { FAQPageSchema, BreadcrumbListSchema, WebPageSchema } from "@/components/feature/SEOHead";

export default function About() {
  return (
    <>
      <WebPageSchema
        title="关于我们 - 木瓜影视"
        description="木瓜影视品牌介绍、用户口碑及联系方式。高清不缓冲在线观看平台，500万+用户的共同选择。"
        url="https://www.muguays.com/about"
        dateModified="2026-08-02"
      />
      <BreadcrumbListSchema
        items={[
          { name: "首页", url: "https://www.muguays.com/" },
          { name: "关于我们", url: "https://www.muguays.com/about" },
        ]}
      />
      <FAQPageSchema
        questions={[
          {
            question: "木瓜影视真的是完全免费的吗？",
            answer: "是的，木瓜影视始终坚持免费运营。所有影视内容均可免费在线观看，无需注册会员，无需支付任何费用。我们通过其他合规的商业合作模式维持运营，不会向用户收费。",
          },
          {
            question: "为什么木瓜影视可以不卡顿不缓冲？",
            answer: "我们采用了自研的智能CDN分发系统和P2P加速技术，在全球部署了加速节点。同时，我们的自适应码率技术可以根据用户的网络状况自动调整清晰度，确保每一秒都流畅播放。",
          },
          {
            question: "木瓜影视的片源更新速度快吗？",
            answer: "非常快。我们与多家内容提供商建立了合作关系，热门电视剧播出后最快2小时内即可更新上线。电影方面，院线电影下映后也会在最短时间内上架。",
          },
          {
            question: "木瓜影视支持哪些设备观看？",
            answer: "木瓜影视支持PC端浏览器、手机浏览器、平板等多种设备。我们采用了响应式设计，在不同屏幕尺寸下都能获得良好的观看体验。未来还会推出专属App。",
          },
          {
            question: "为什么木瓜影视没有广告？",
            answer: "我们相信纯净的观影体验才是用户真正需要的。相比于通过广告获取收入，我们更愿意通过优质的服务和口碑吸引更多用户，探索更可持续的商业模式。",
          },
        ]}
      />
      <header className="pt-20 pb-8 px-4 md:px-6 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700 whitespace-nowrap">关于我们</span>
          </nav>
          <h1 className="font-heading text-xl md:text-2xl text-foreground-900 mb-2">
            关于木瓜影视
          </h1>
          <p className="text-sm text-foreground-500">
            高清不缓冲，在线观看不卡顿
          </p>
        </div>
      </header>

      <section className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 mb-12">
            <div>
              <h2 className="font-heading text-lg text-foreground-900 mb-4">
                品牌介绍
              </h2>
              <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                <p>
                  木瓜影视成立于2020年，是一家专注于高清在线影视内容聚合与分发的互联网平台。我们致力于为广大观众提供高清不缓冲的在线观看体验，让每一位用户都能享受流畅无忧的观影时光。
                </p>
                <p>
                  平台涵盖了最新电视剧、电影、动漫、综艺、纪录片等全品类影视内容，与多家国内外知名内容提供商建立了深度合作关系，确保内容的丰富性和更新的及时性。无论是热播剧集还是经典老片，在木瓜影视都能找到。
                </p>
                <p>
                  我们的技术团队在视频编解码和CDN加速领域拥有丰富的经验，通过自研的智能分发系统，实现了真正意义上的不缓冲不卡顿播放体验。同时，我们坚持免费无广告的运营理念，为用户提供纯净的观影环境。
                </p>
                <div className="grid grid-cols-2 gap-4 mt-6">
                  <div className="p-4 rounded-xl bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-2">
                      <i className="ri-user-smile-line text-lg"></i>
                    </div>
                    <p className="text-lg font-medium text-foreground-900">500万+</p>
                    <p className="text-xs text-foreground-500">月活跃用户</p>
                  </div>
                  <div className="p-4 rounded-xl bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-2">
                      <i className="ri-movie-line text-lg"></i>
                    </div>
                    <p className="text-lg font-medium text-foreground-900">10万+</p>
                    <p className="text-xs text-foreground-500">影视资源</p>
                  </div>
                  <div className="p-4 rounded-xl bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-2">
                      <i className="ri-global-line text-lg"></i>
                    </div>
                    <p className="text-lg font-medium text-foreground-900">50+</p>
                    <p className="text-xs text-foreground-500">合作内容方</p>
                  </div>
                  <div className="p-4 rounded-xl bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-2">
                      <i className="ri-time-line text-lg"></i>
                    </div>
                    <p className="text-lg font-medium text-foreground-900">24h</p>
                    <p className="text-xs text-foreground-500">内容更新周期</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-lg text-foreground-900 mb-4">
                我们的优势
              </h2>
              <div className="space-y-4">
                {[
                  {
                    icon: "ri-4k-line",
                    title: "高清画质体验",
                    desc: "支持1080P至4K超清画质，自适应码率技术根据网络状况智能切换，确保最佳观看体验。画面清晰细腻，色彩还原真实，让每一帧都栩栩如生。",
                  },
                  {
                    icon: "ri-speed-up-line",
                    title: "极速播放不卡顿",
                    desc: "全球CDN加速节点覆盖，自研P2P分发技术，大幅降低缓冲等待时间。无论身在何处，都能享受丝滑流畅的播放体验。",
                  },
                  {
                    icon: "ri-shield-check-line",
                    title: "纯净无广告",
                    desc: "始终坚持免费无广告的运营理念，不插入任何形式的贴片广告、弹窗广告或植入广告，让观影回归纯粹。",
                  },
                  {
                    icon: "ri-refresh-line",
                    title: "实时更新",
                    desc: "与各大平台同步更新最新内容，热门电视剧播出后最快2小时内即可上线，不错过任何精彩。",
                  },
                ].map((item) => (
                  <div key={item.title} className="flex gap-4 p-4 rounded-xl bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-medium text-foreground-900 mb-1">{item.title}</h3>
                      <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-lg text-foreground-900 mb-6 text-center">
            用户口碑
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {[
              {
                name: "影视爱好者小王",
                comment: "用木瓜影视已经两年了，画质清晰播放流畅，关键是真的没有广告！推荐给了好多朋友，都说好用。",
                rating: 5,
              },
              {
                name: "追剧达人小李",
                comment: "更新速度真的快，热播剧基本同步上线。高清不缓冲这点太赞了，在公司午休看剧完全不卡。",
                rating: 5,
              },
              {
                name: "资深影迷老张",
                comment: "片源很全，很多老电影和冷门佳片都能找到。画质比想象中好很多，4K看着就是爽，而且是完全免费的。",
                rating: 5,
              },
              {
                name: "学生党小陈",
                comment: "免费高清观影真的太香了！宿舍网不太好但木瓜影视的播放还是很流畅，自动适配码率这个功能很实用。",
                rating: 5,
              },
              {
                name: "宝妈刘女士",
                comment: "周末给娃放动画片，画面清晰声音好。没有乱七八糟的广告弹窗，不用担心孩子点到不该点的东西。",
                rating: 4,
              },
              {
                name: "夜班族阿明",
                comment: "上夜班的时候就靠木瓜影视打发时间了。资源更新快，分类也清楚，找剧很方便。用了这么久基本没有遇到过卡顿。",
                rating: 5,
              },
            ].map((review) => (
              <div key={review.name} className="p-5 rounded-xl bg-background-50">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i
                        className={`text-sm ${
                          i < review.rating
                            ? "ri-star-fill text-accent-500"
                            : "ri-star-line text-foreground-300"
                        }`}
                      ></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  &ldquo;{review.comment}&rdquo;
                </p>
                <p className="text-xs text-foreground-500">—— {review.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-lg text-foreground-900 mb-6 text-center">
            常见问题
          </h2>
          <div className="space-y-3 max-w-3xl mx-auto">
            {[
              {
                q: "木瓜影视真的是完全免费的吗？",
                a: "是的，木瓜影视始终坚持免费运营。所有影视内容均可免费在线观看，无需注册会员，无需支付任何费用。我们通过其他合规的商业合作模式维持运营，不会向用户收费。",
              },
              {
                q: "为什么木瓜影视可以不卡顿不缓冲？",
                a: "我们采用了自研的智能CDN分发系统和P2P加速技术，在全球部署了加速节点。同时，我们的自适应码率技术可以根据用户的网络状况自动调整清晰度，确保每一秒都流畅播放。",
              },
              {
                q: "木瓜影视的片源更新速度快吗？",
                a: "非常快。我们与多家内容提供商建立了合作关系，热门电视剧播出后最快2小时内即可更新上线。电影方面，院线电影下映后也会在最短时间内上架。",
              },
              {
                q: "木瓜影视支持哪些设备观看？",
                a: "木瓜影视支持PC端浏览器、手机浏览器、平板等多种设备。我们采用了响应式设计，在不同屏幕尺寸下都能获得良好的观看体验。未来还会推出专属App。",
              },
              {
                q: "为什么木瓜影视没有广告？",
                a: "我们相信纯净的观影体验才是用户真正需要的。相比于通过广告获取收入，我们更愿意通过优质的服务和口碑吸引更多用户，探索更可持续的商业模式。",
              },
            ].map((faq, idx) => (
              <details key={idx} className="group rounded-xl bg-background-100 overflow-hidden">
                <summary className="flex items-center justify-between p-4 cursor-pointer text-sm font-medium text-foreground-900">
                  {faq.q}
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2">
                    <i className="ri-arrow-down-s-line group-open:hidden"></i>
                    <i className="ri-arrow-up-s-line hidden group-open:block"></i>
                  </div>
                </summary>
                <div className="px-4 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-lg text-foreground-900 mb-6 text-center">
            联系我们
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-3xl mx-auto">
            <div className="p-5 rounded-xl bg-background-50 text-center">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">business@muguays.com</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 text-center">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-customer-service-line text-lg"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">用户反馈</h3>
              <p className="text-xs text-foreground-500">feedback@muguays.com</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 text-center">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                <i className="ri-shield-user-line text-lg"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">版权申诉</h3>
              <p className="text-xs text-foreground-500">copyright@muguays.com</p>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="font-heading text-lg text-foreground-900 mb-3">
            开始你的观影之旅
          </h2>
          <p className="text-sm text-foreground-500 mb-6 max-w-xl mx-auto">
            加入500万+用户的行列，体验高清不缓冲的在线观影乐趣
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/movie"
              className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览电影
            </Link>
            <Link
              to="/category/tv"
              className="px-6 py-2.5 bg-background-100 hover:bg-background-200 text-foreground-700 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              追剧列表
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}